import type { ImageElement } from "@ai-teach/types";

interface ImageRendererProps {
  element: ImageElement;
  isLiveMode?: boolean;
}

export function ImageRenderer({ element }: ImageRendererProps) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        borderRadius: element.border.cornerRadius - element.border.strokeWidth,
      }}
    >
      <img
        src={element.media.src ?? ""}
        alt={element.media.filename ?? "image"}
        draggable={false}
        style={{
          width: "100%",
          height: "100%",
          objectFit: element.objectFit ?? "contain",
          pointerEvents: "none",
          userSelect: "none",
        }}
      />
    </div>
  );
}
